var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdpresent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0998 19.4502C10.4235 19.4502 9.7749 19.7189 9.29668 20.1971C8.81846 20.6753 8.5498 21.3239 8.5498 22.0002V35.9002C8.5498 36.3144 8.21402 36.6502 7.7998 36.6502C7.38559 36.6502 7.0498 36.3144 7.0498 35.9002V22.0002C7.0498 20.9261 7.4765 19.8959 8.23602 19.1364C8.99554 18.3769 10.0257 17.9502 11.0998 17.9502H24.1998C24.614 17.9502 24.9498 18.286 24.9498 18.7002C24.9498 19.1144 24.614 19.4502 24.1998 19.4502H11.0998Z",
    fill: "#785AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3496 19.1001C66.3496 18.6859 66.6854 18.3501 67.0996 18.3501H80.8996C81.9737 18.3501 83.0039 18.7768 83.7634 19.5363C84.5229 20.2958 84.9496 21.326 84.9496 22.4001V35.5001C84.9496 35.9143 84.6138 36.2501 84.1996 36.2501C83.7854 36.2501 83.4496 35.9143 83.4496 35.5001V22.4001C83.4496 21.7238 83.181 21.0752 82.7027 20.597C82.2245 20.1188 81.5759 19.8501 80.8996 19.8501H67.0996C66.6854 19.8501 66.3496 19.5143 66.3496 19.1001Z",
    fill: "#785AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1998 58.8501C84.614 58.8501 84.9498 59.1859 84.9498 59.6001V73.5001C84.9498 74.5742 84.5231 75.6044 83.7636 76.3639C83.0041 77.1234 81.9739 77.5501 80.8998 77.5501H67.7998C67.3856 77.5501 67.0498 77.2143 67.0498 76.8001C67.0498 76.3859 67.3856 76.0501 67.7998 76.0501H80.8998C81.5761 76.0501 82.2247 75.7814 82.7029 75.3032C83.1811 74.825 83.4498 74.1764 83.4498 73.5001V59.6001C83.4498 59.1859 83.7856 58.8501 84.1998 58.8501Z",
    fill: "#785AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7998 59.25C8.21402 59.25 8.5498 59.5858 8.5498 60V73.1C8.5498 73.7763 8.81846 74.4249 9.29668 74.9031C9.7749 75.3813 10.4235 75.65 11.0998 75.65H24.8998C25.314 75.65 25.6498 75.9858 25.6498 76.4C25.6498 76.8142 25.314 77.15 24.8998 77.15H11.0998C10.0257 77.15 8.99554 76.7233 8.23602 75.9638C7.4765 75.2043 7.0498 74.1741 7.0498 73.1V60C7.0498 59.5858 7.38559 59.25 7.7998 59.25Z",
    fill: "#785AFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0373 75.1007C23.0373 75.1007 22.441 70.0322 26.0188 65.8581C29.1493 62.2058 35.5595 59.2988 45.473 59.2988C55.1628 59.2988 61.4985 61.9822 64.7036 65.709C68.4305 70.0322 67.9832 75.3989 67.9832 75.3989L23.0373 75.1007Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5654 35.7449C30.5654 43.8695 31.0127 61.0131 46.5164 61.0131C62.0202 61.0131 61.3493 43.1241 61.3493 35.7449C61.3493 28.3658 58.5914 16.5889 45.9201 16.5889C33.2488 16.5889 30.5654 26.4278 30.5654 35.7449Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.491 37.2356C30.491 37.2356 35.7086 31.4962 37.423 23.1481C37.423 23.1481 48.7527 29.6328 57.3245 27.8439C57.3245 27.8439 58.8152 34.7013 61.2749 36.1175C61.2749 36.1175 66.418 28.8874 63.0638 18.5268C59.9333 8.91145 40.2554 4.96097 35.7086 16.9615C35.7832 16.8869 21.9938 18.974 30.491 37.2356Z",
    fill: "#8362E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2984 40.3663C41.8747 40.3663 42.3419 39.4653 42.3419 38.3538C42.3419 37.2423 41.8747 36.3413 41.2984 36.3413C40.7221 36.3413 40.2549 37.2423 40.2549 38.3538C40.2549 39.4653 40.7221 40.3663 41.2984 40.3663Z",
    fill: "#8362E2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9888 40.3663C51.5652 40.3663 52.0324 39.4653 52.0324 38.3538C52.0324 37.2423 51.5652 36.3413 50.9888 36.3413C50.4125 36.3413 49.9453 37.2423 49.9453 38.3538C49.9453 39.4653 50.4125 40.3663 50.9888 40.3663Z",
    fill: "#8362E2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4109 39.77C47.6345 41.708 49.1998 48.1182 48.678 49.0126C48.1563 49.9071 44.7275 48.64 44.7275 48.64",
    stroke: "#8362E2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2988 52.3667C41.2988 52.3667 42.2678 54.9009 46.2183 54.9009C50.2433 54.9009 50.616 51.9194 50.616 51.9194",
    stroke: "#8362E2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.808 59.5967C24.6769 61.6837 23.4098 69.3611 23.0371 75.0259",
    stroke: "#8362E2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5537 59.8203C66.4176 62.5782 67.6102 69.6592 67.9829 75.0259",
    stroke: "#8362E2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5654 35.7449C30.5654 43.8695 31.0127 61.0131 46.5164 61.0131C62.0202 61.0131 61.3493 43.1241 61.3493 35.7449C61.3493 28.3658 58.5914 16.5889 45.9201 16.5889C33.2488 16.5889 30.5654 26.4278 30.5654 35.7449Z",
    stroke: "#8362E2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 28,
    r: 3,
    fill: "#8362E2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdpresent);
export default __webpack_public_path__ + "static/media/idpresent.a1958d38c0204cdfd89665604b7686ba.svg";
export { ForwardRef as ReactComponent };